import request from '@/utils/request'
import axios from 'axios'

/**
 * 上传演讲者头像
 * @param {File} file 头像文件
 * @param {Function} progressCallback 上传进度回调函数
 * @returns {Promise}
 */
export async function uploadSpeakerAvatar(file, progressCallback = null) {
  const formData = new FormData()
  formData.append('file', file)
  
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  
  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }
  
  const response = await axios.post(process.env.VUE_APP_API_URL + '/speaker-avatar-upload', formData, config)
  return response.data
}

/**
 * 上传演讲者视频
 * @param {File} file 视频文件
 * @param {Function} progressCallback 上传进度回调函数
 * @returns {Promise}
 */
export async function uploadSpeakerVideo(file, progressCallback = null) {
  const formData = new FormData()
  formData.append('file', file)
  
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  
  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }
  
  const response = await axios.post(process.env.VUE_APP_API_URL + '/speaker-video-upload', formData, config)
  return response.data
}

/**
 * 创建演讲者
 * @param {Object} data 演讲者数据
 * @param {Function} progressCallback 上传进度回调函数
 * @returns {Promise}
 */
export async function createSpeaker(data, progressCallback = null) {
  const formData = new FormData()
  
  // 添加基本信息
  if (data.name_zh) formData.append('name_zh', data.name_zh)
  if (data.name_en) formData.append('name_en', data.name_en)
  if (data.bio_zh) formData.append('bio_zh', data.bio_zh)
  if (data.bio_en) formData.append('bio_en', data.bio_en)
  if (data.avatar_temp_path) formData.append('avatar_temp_path', data.avatar_temp_path)
  if (data.video_temp_path) formData.append('video_temp_path', data.video_temp_path)
  if (data.video_url) formData.append('video_url', data.video_url)
  // 分组字段：undefined 表示不修改，空字符串表示删除分组
  if (data.group_name !== undefined) {
    formData.append('group_name', data.group_name)
  }
  if (data.sort_order !== undefined && data.sort_order !== null && data.sort_order !== '') {
    formData.append('sort_order', data.sort_order)
  }

  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }

  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }

  const response = await axios.post(process.env.VUE_APP_API_URL + '/speakers', formData, config)
  return response.data
}

/**
 * 获取演讲者列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getSpeakers(params) {
  return request({
    url: '/speakers',
    method: 'get',
    params
  })
}

/**
 * 获取单个演讲者详情
 * @param {Number} speakerId 演讲者ID
 * @returns {Promise}
 */
export function getSpeaker(speakerId) {
  return request({
    url: `/speakers/${speakerId}`,
    method: 'get'
  })
}

/**
 * 更新演讲者信息
 * @param {Number} speakerId 演讲者ID
 * @param {Object} data 更新数据
 * @param {Function} progressCallback 上传进度回调函数
 * @returns {Promise}
 */
export async function updateSpeaker(speakerId, data, progressCallback = null) {
  const formData = new FormData()
  
  // 添加更新信息
  if (data.name_zh) formData.append('name_zh', data.name_zh)
  if (data.name_en) formData.append('name_en', data.name_en)
  if (data.bio_zh) formData.append('bio_zh', data.bio_zh)
  if (data.bio_en) formData.append('bio_en', data.bio_en)
  if (data.avatar_temp_path) formData.append('avatar_temp_path', data.avatar_temp_path)
  if (data.video_temp_path) formData.append('video_temp_path', data.video_temp_path)
  if (data.video_url) formData.append('video_url', data.video_url)
  // 分组字段：undefined 表示不修改，空字符串表示删除分组
  if (data.group_name !== undefined) {
    formData.append('group_name', data.group_name)
  }
  if (data.sort_order !== undefined && data.sort_order !== null && data.sort_order !== '') {
    formData.append('sort_order', data.sort_order)
  }

  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }

  if (progressCallback) {
    config.onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      progressCallback(percentCompleted)
    }
  }

  const response = await axios.put(process.env.VUE_APP_API_URL + `/speakers/${speakerId}`, formData, config)
  return response.data
}

/**
 * 删除演讲者
 * @param {Number} speakerId 演讲者ID
 * @returns {Promise}
 */
export function deleteSpeaker(speakerId) {
  return request({
    url: `/speakers/${speakerId}`,
    method: 'delete'
  })
}